import { Box, Button, Typography, Stack } from "@mui/material";

interface Package {
  name: string;
  price: string;
  features: string[];
  isFeatured: boolean;
  badge: string;
}

const packagesData: Package[] = [
  {
    name: "Muzukuru X",
    price: "$499.00",
    features: ["2 Camera Setup", "Broadcast On Youtube"],
    isFeatured: false,
    badge: "/purple-gem.svg",
  },
  {
    name: "Muzukuru Pro",
    price: "$699.00",
    features: ["3 Camera Setup", "Broadcast On Youtube"],
    isFeatured: true,
    badge: "/green-gem.svg",
  },
  {
    name: "Muzukuru Lux",
    price: "$1,299.00",
    features: ["4 Camera Setup", "Broadcast On Youtube"],
    isFeatured: false,
    badge: "/red-gem.svg",
  },
];

const PackagesSection = () => {
  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: "#fff",
        py: { xs: "48px", md: "72px" },
        px: { xs: "24px", md: "80px" },
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          maxWidth: "1152px",
          mx: "auto",
          position: "relative",
          zIndex: 2,
        }}
      >
        {/* Header */}
        <Box mb={2}>
          <Typography
            sx={{
              fontSize: { xs: "32px", md: "40px" },
              fontWeight: 700,
              color: "#111111",
              mb: 2,
            }}
          >
            Packages
          </Typography>

          <Typography
            sx={{
              fontFamily: "Mulish",
              fontWeight: 400,
              fontSize: { xs: "15px", md: "17px" },
              color: "#737373",
              lineHeight: 1.7,
              maxWidth: "700px",
            }}
          >
            For over two decades, Muzukuru has been a trusted name in funeral
            services, providing compassionate care to families across Zimbabwe.
          </Typography>
        </Box>

        {/* Gradient Container */}
        <Box pt={7}>
          <Box
            sx={{
              borderRadius: "40px",
              px: { xs: 3, md: 5 },
              pb: 4,
              pt: { xs: 5, md: 2 },
              background:
                "linear-gradient(135deg, #5C3423 0%, #9E715C 60%, #B5856F 100%)",
            }}
          >
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "1fr",
                  md: "1fr 1.15fr 1fr",
                },
                gap: 3,
                alignItems: "end",
              }}
            >
              {packagesData.map((pkg) => (
                <Box
                  key={pkg.name}
                  sx={{
                    borderRadius: "40px",
                    p: 4,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",

                    minHeight: pkg.isFeatured ? 440 : 380,

                    bgcolor: pkg.isFeatured ? "#fff" : "transparent",

                    color: pkg.isFeatured ? "#111111" : "#fff",

                    position: "relative",

                    zIndex: pkg.isFeatured ? 30 : 1,

                    mt: pkg.isFeatured ? { xs: 0, md: "-64px" } : 0,

                    boxShadow: pkg.isFeatured
                      ? "0 30px 60px -15px rgba(0,0,0,0.4)"
                      : "none",

                    border: pkg.isFeatured
                      ? "1px solid rgba(158,113,92,.25)"
                      : "none",
                  }}
                >
                  <Box>
                    {/* Name */}
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: "24px",
                        mb: 1,
                      }}
                    >
                      {pkg.name}
                    </Typography>

                    {/* Price */}
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: "20px",
                        mb: 4,
                        opacity: 0.9,
                      }}
                    >
                      {pkg.price}
                    </Typography>

                    {/* Features */}
                    <Box mb={4}>
                      <Typography
                        sx={{
                          fontSize: "12px",
                          fontWeight: 700,
                          textTransform: "uppercase",
                          letterSpacing: "1.5px",
                          mb: 3,
                          color: pkg.isFeatured
                            ? "#9CA3AF"
                            : "rgba(255,255,255,.7)",
                        }}
                      >
                        Features
                      </Typography>

                      <Stack spacing={2}>
                        {pkg.features.map((feature, index) => (
                          <Stack
                            key={index}
                            direction="row"
                            spacing={1.5}
                            alignItems="flex-start"
                          >
                            <Box
                              sx={{
                                width: 6,
                                height: 6,
                                borderRadius: "50%",
                                mt: "7px",
                                flexShrink: 0,
                                bgcolor: pkg.isFeatured
                                  ? "#111111"
                                  : "rgba(255,255,255,.8)",
                              }}
                            />

                            <Typography
                              sx={{
                                fontSize: "14px",
                                lineHeight: 1.5,
                                color: pkg.isFeatured ? "#525252" : "#E5E5E5",
                              }}
                            >
                              {feature}
                            </Typography>
                          </Stack>
                        ))}
                      </Stack>
                    </Box>
                  </Box>

                  {/* Button */}
                  <Button
                    fullWidth
                    sx={{
                      py: 1.75,
                      borderRadius: "12px",
                      fontWeight: 700,
                      textTransform: "none",

                      background: pkg.isFeatured
                        ? "linear-gradient(135deg, #5C3423 0%, #9E715C 60%, #B5856F 100%)"
                        : "#fff",

                      color: pkg.isFeatured ? "#fff" : "#5C3423",

                      "&:hover": {
                        opacity: 0.95,
                        background: pkg.isFeatured
                          ? "linear-gradient(135deg, #5C3423 0%, #9E715C 60%, #B5856F 100%)"
                          : "#f7f7f7",
                      },
                    }}
                  >
                    Select Package
                  </Button>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default PackagesSection;
